import { Box, Tooltip, type SxProps } from '@mui/material'

interface Props {
  width?: string
  height?: string
  sx?: SxProps
}

export const InactivePersonIcon = (props: Props): JSX.Element => {
  return <Tooltip title='User has been disabled.'>
    <Box sx={props.sx ?? {}}>
      <svg width={props.width ?? '18'} height={props.height ?? '21'} viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.62061 13.4724C7.51645 13.2878 8.43895 13.2846 9.3335 13.4626V19.6667H1.18701C1.25065 18.7963 1.47837 17.9444 1.86377 17.158C2.32278 16.2214 2.99043 15.4023 3.81494 14.7634C4.63943 14.1246 5.59908 13.6829 6.62061 13.4724ZM16.9497 14.5544L15.3589 16.1462L15.0054 16.4998L16.9497 18.4441L16.3599 19.0339L14.77 17.4431L14.4165 17.0886L14.063 17.4431L12.4722 19.0339L11.8823 18.4441L13.4741 16.8533L13.8276 16.4998L11.8823 14.5544L12.4712 13.9656L14.4165 15.9109L14.77 15.5574L16.3608 13.9656L16.9497 14.5544ZM7.99951 1.41675C10.7621 1.41675 12.9995 3.65414 12.9995 6.41675C12.9995 9.17936 10.7621 11.4167 7.99951 11.4167C5.23705 11.4166 2.99951 9.17925 2.99951 6.41675C2.99951 3.65425 5.23705 1.41692 7.99951 1.41675Z" fill="#52525B" stroke="black"/>
      </svg>
    </Box>
  </Tooltip>
}
